"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ChevronDownSmall;

var _ChevronDownSmall = require("@adobe/react-spectrum-ui/dist/ChevronDownSmall.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ChevronDownSmall(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ChevronDownSmall.ChevronDownSmall, null));
}